/**
 * Tiện ích xử lý số điện thoại di động Việt Nam.
 *
 * Chức năng:
 * - Chuẩn hóa (84 → 0, thêm 0 đầu, giới hạn 10 chữ số).
 * - Format hiển thị (4-3-3).
 * - Validate theo regex nhà mạng VN.
 */
/** Regex SĐT di động Việt Nam hợp lệ (bắt đầu 0, đúng đầu số nhà mạng) */
const VN_MOBILE_REGEX = /^(0)(3[2-9]|5[25689]|7[06-9]|8[1-9]|9[0-9])[0-9]{7}$/;

/**
 * Loại bỏ mọi ký tự không phải số.
 * @param {string} [value]
 * @returns {string}
 */
export const stripPhoneDigits = (value = '') => String(value).replace(/\D/g, '');

/**
 * Chuẩn hóa SĐT về dạng 10 chữ số bắt đầu bằng 0.
 * @param {string} [value]
 * @returns {string}
 */
export const normalizeVietnamesePhone = (value = '') => {
  let digits = stripPhoneDigits(value);

  // Chuyển mã quốc gia 84 thành 0
  if (digits.startsWith('84')) {
    digits = `0${digits.slice(2)}`;
  }

  if (digits && !digits.startsWith('0')) {
    digits = `0${digits}`;
  }

  return digits.slice(0, 10);
};

/**
 * Format SĐT để hiển thị: 0xxx xxx xxx.
 * @param {string} [value]
 * @returns {string}
 */
export const formatVietnamesePhone = (value = '') => {
  const normalized = normalizeVietnamesePhone(value);

  if (!normalized) {
    return '';
  }

  if (normalized.length <= 4) {
    return normalized;
  }

  if (normalized.length <= 7) {
    return `${normalized.slice(0, 4)} ${normalized.slice(4)}`;
  }

  return `${normalized.slice(0, 4)} ${normalized.slice(4, 7)} ${normalized.slice(7, 10)}`;
};

/** Alias formatVietnamesePhone — dùng trong input onChange */
export const formatPhoneInput = (value = '') => formatVietnamesePhone(value);

/**
 * Kiểm tra SĐT có hợp lệ theo regex VN không.
 * @param {string} [value]
 * @returns {boolean}
 */
export const isValidVietnamesePhone = (value = '') =>
  VN_MOBILE_REGEX.test(normalizeVietnamesePhone(value));

/**
 * Trả về key lỗi validation (phoneRequired / phoneInvalid) hoặc chuỗi rỗng nếu hợp lệ.
 * @param {string} [value]
 * @param {Object} [options]
 * @param {boolean} [options.required=false]
 * @returns {string}
 */
export const getPhoneValidationError = (value = '', { required = false } = {}) => {
  const normalized = normalizeVietnamesePhone(value);

  if (!normalized) {
    return required ? 'phoneRequired' : '';
  }

  if (!isValidVietnamesePhone(normalized)) {
    return 'phoneInvalid';
  }

  return '';
};
